import styled from "styled-components";
import { GradientBackground } from "../../GradientBackground/GradientBackground";
import { Heading } from "../../common/Heading/Heading";
import { useTranslation } from "react-i18next";
import { media } from "../../../styles/mixins";
import { Button } from "../../common/Button/Button";
import { COLORS } from "../../../assets/constants/styles";
import { FullWidthSectionWithContent } from "../../common/FullWidthSectionWithContent";
import { openExtensionStore } from "../../../helpers/various-helpers";
import { useState } from "react";
import { DemoModal } from "../../common/DemoModal/DemoModal";
import { Amocrm } from "../../../assets/images/Amocrm";
import { AmocrmActive } from "../../../assets/images/AmocrmActive";
import { AmocrmTop } from "../../../assets/images/AmocrmTop";
import { UseDesk } from "../../../assets/images/UseDesk";
import { UseDeskActive } from "../../../assets/images/UseDeskActive";
import { UseDeskTop } from "../../../assets/images/UseDeskTop";
import { HelpDeskEddy } from "../../../assets/images/HelpDeskEddy";
import { HelpDeskEddyActive } from "../../../assets/images/HelpDeskEddyActive";
import { HelpDeskEddyTop } from "../../../assets/images/HelpDeskEddyTop";
import { trackEvent } from "../../../helpers/analytics-helpers";
export const Top = ({ activeCrm, setActiveCrm }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const crmMap = {
    AmoCRM: {
      name: "AmoCRM",
      icon: <Amocrm />,
      iconActive: <AmocrmActive />,
      topImage: <AmocrmTop />,
    },
    UseDesk: {
      name: "UseDesk",
      icon: <UseDesk />,
      iconActive: <UseDeskActive />,
      topImage: <UseDeskTop />,
    },

    HelpDeskEddy: {
      name: "HelpDeskEddy",
      icon: <HelpDeskEddy />,
      iconActive: <HelpDeskEddyActive />,
      topImage: <HelpDeskEddyTop />,
    },
  };

  return (
    <>
      <FullWidthSectionWithContent>
        <TopWrapper id="top">
          <GradientBackground />
          <TopContainer>
            <Heading size={1} text={t("top.title")} />
            <Caption>{t("top.caption")}</Caption>
            <ButtonSection>
              <Button
                text={t("buttons.try")}
                onClick={() => {
                  // eslint-disable-next-line no-undef
                  ym(100699774, "reachGoal", "TRY_NOW");
                  trackEvent("try-now");
                  openExtensionStore();
                }}
              />

              <Button
                text={t("buttons.demoCall")}
                variant="transparent"
                onClick={() => {
                  // eslint-disable-next-line no-undef
                  ym(100699774, "reachGoal", "DEMO_CALL");
                  trackEvent("demo-call");
                  setIsModalOpen(true);
                }}
              />
            </ButtonSection>

            <CrmContainer>
              {Object.keys(crmMap).map((crm) => {
                return (
                  <CrmButtonContainer key={crm}>
                    <CrmButton
                      onClick={() => {
                        setActiveCrm(crm);
                      }}
                      $isActive={activeCrm === crm}
                    >
                      {activeCrm === crm
                        ? crmMap[crm].iconActive
                        : crmMap[crm].icon}
                    </CrmButton>
                    <CrmCaption
                      key={`${crm}-name`}
                      $isActive={activeCrm === crm}
                    >
                      {crmMap[crm].name}
                    </CrmCaption>
                  </CrmButtonContainer>
                );
              })}
            </CrmContainer>
            <ImageContainer>{crmMap[activeCrm].topImage}</ImageContainer>
          </TopContainer>
        </TopWrapper>
      </FullWidthSectionWithContent>
      <DemoModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: 100%;

  padding-top: 104px;

  ${media.tablet(`
    padding-top: 125px;
  `)}

  ${media.laptop(`
    padding-top: 144px;
  `)};
`;

const TopContainer = styled.div`
  max-width: 21.438rem;
  display:flex;
  flex-direction:column;
  align-items-center;

  ${media.tablet(`
      max-width: 45rem;
    `)}

  ${media.laptop(`
      max-width: 58.5rem;
    `)}
`;

const Caption = styled.div`
  margin: 28px 0;
`;

const ButtonSection = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-bottom: 32px;

  ${media.laptop(`
    margin-bottom: 40px;
  `)}
`;

const CrmContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 53px;
`;

const CrmButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
`;

const CrmCaption = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 14.4px;
  text-align: center;
  color: ${(props) => (props.$isActive ? COLORS.black : COLORS.grey)};
`;

const CrmButton = styled.div`
  display: flex;
  width: 100%;
  width: 64px;
  height: 64px;
  ${(props) => !props.$isActive && "transform: scale(1.25)"};

  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    ${(props) => !props.$isActive && "transform: scale(1.66)"}
  }
`;

const ImageContainer = styled.div`
  margin-top: 30px;

  ${media.tablet(`
    margin-top: 20px;
  `)}
`;
